
    import {track} from '@malt/tracking';
    import {Inject, Options, Vue} from 'vue-property-decorator';
    import RecommendationSide from '@/profile-creation-wizard/components/for-completion/ui/6_recommendation/RecommendationSide.vue';
    import {ReasonForJoining} from '@/profile-creation-wizard/components/for-completion/domain/types';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {ProfileCompletionRepositoryAPI} from '@/profile-creation-wizard/components/for-completion/infra/repository/ProfileCompletionRepositoryAPI';
    import AskForRecommendation from '@/profile-creation-wizard/components/for-completion/ui/6_recommendation/AskForRecommendation.vue';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';
    import StepActions from '@/profile-creation-wizard/common/ui/step/StepActions.vue';
    import StepMobileHeader from '@/profile-creation-wizard/common/ui/step/StepMobileHeader.vue';
    import {TrackingRepository} from '@/common/repositories/track/TrackingRepository';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import getters from '@/profile-creation-wizard/store/completion/getters';
    import mutations from '@/profile-creation-wizard/store/completion/mutations';
    import {RouteRecordNameGeneric} from 'vue-router';

    type Form = {
        reasonForJoining: Array<ReasonForJoining>;
        recoEmails: string;
        recoTextToSend: string;
    };

    const defaultForm: Form = {
        reasonForJoining: [],
        recoEmails: '',
        recoTextToSend: '',
    };

    @Options({
        components: {
            Step,
            AskForRecommendation,
            RecommendationSide,
            StepActions,
            StepMobileHeader,
        },
    })
    export default class RecommendationStep extends Vue {
        @Inject({from: DI.profileCompletionRepository})
        profileCompletionRepository!: ProfileCompletionRepositoryAPI;

        @Inject({from: DI.trackingRepository})
        trackingRepository!: TrackingRepository;

        customData: Form = defaultForm;
        isLoadingButtonNext = false;

        mounted() {
            this.data = this.$store.getters[getters.recommendations];
        }

        get hasValidFieldPart(): boolean {
            return this.hasRecoToSend;
        }

        get hasRecoToSend(): boolean {
            return this.customData.recoEmails.trim().length > 0 && this.customData.recoTextToSend.trim().length > 0;
        }

        changeRecoEmails(emails: string): void {
            this.customData.recoEmails = emails;
            this.$store.commit(mutations.setRecommendations, this.data);
        }

        changeRecoText(text: string): void {
            this.customData.recoTextToSend = text;
            this.$store.commit(mutations.setRecommendations, this.data);
        }

        async goNext(): Promise<void> {
            this.isLoadingButtonNext = true;

            if (this.hasRecoToSend) {
                const [, error] = await this.profileCompletionRepository.sendRecommendationRequests(
                    this.customData.recoEmails,
                    this.customData.recoTextToSend,
                );
                if (error && error.response?.data.length > 0) {
                    this.isLoadingButtonNext = false;
                    const message = this.getErrorMessage(error);
                    pushVJoySnackbar({
                        props: {
                            message,
                            level: 'error',
                        },
                    });
                    return;
                }
            }
            track('invitation_sent', {url: window.location.pathname, origin: 'your-recommendations', type: 'emails-sent'});

            this.trackingRepository.track(`sent-recommendations-${this.$store.state.funnelMode}`, {
                'sent-recommendations': this.hasRecoToSend ? this.customData.recoEmails.split(',').length : 0,
            });

            this.$router.push({name: this.$router.currentRoute.value.meta.nextStep as RouteRecordNameGeneric});
            this.isLoadingButtonNext = false;
        }

        private getErrorMessage(error) {
            if (Array.isArray(error.response?.data)) {
                return error.response?.data[0].error;
            } else {
                return error.response?.data;
            }
        }
    }
